/**
 * mapConfig.js
 * Centralized MapLibre configuration and constants (ESRI World Imagery tiles, no API key required)
 */

export const CAMPUS_CONFIG = {
  // Contiguous United States center
  center: [
    parseFloat(process.env.REACT_APP_CAMPUS_CENTER_LNG) || -99.5795,
    parseFloat(process.env.REACT_APP_CAMPUS_CENTER_LAT) || 37.8283
  ],
  defaultZoom: 4.5,
  minZoom: parseFloat(process.env.REACT_APP_CAMPUS_ZOOM_MIN) || 2,
  maxZoom: parseFloat(process.env.REACT_APP_CAMPUS_ZOOM_MAX) || 22,

  // Zoom threshold for detailed data display
  detailZoomThreshold: 16,

  // Map style - ESRI World Imagery satellite raster tiles (free, no token)
  style: {
    version: 8,
    // Public glyph server so symbol layers (building labels) can render text
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
    sources: {
      'esri-world-imagery': {
        type: 'raster',
        tiles: [
          'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
        ],
        tileSize: 256,
        maxzoom: 19,
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community'
      }
    },
    layers: [
      {
        id: 'esri-world-imagery-layer',
        type: 'raster',
        source: 'esri-world-imagery'
      }
    ]
  },

  // Map container dimensions
  containerStyle: {
    width: '100%',
    height: '100%'
  }
};

export const MARKER_CONFIG = {
  // Marker size
  size: 30,

  // Hover scale factor
  hoverScale: 1.3,

  // Selected scale factor
  selectedScale: 1.5,

  // Marker border for selected state
  selectedBorder: 3,

  // Debounce delay for hover events (ms)
  hoverDebounceMs: 200,

  // Z-index layers
  zIndex: {
    default: 1,
    hover: 2,
    selected: 3
  }
};

export const POLLING_CONFIG = {
  // Default polling interval (ms) - 1 minute
  defaultInterval: 60000,

  // Retry configuration
  maxRetries: 3,
  retryDelayMs: 2000,

  // Exponential backoff multiplier
  backoffMultiplier: 1.5
};
